import React, { FC } from 'react';
import { Button, Appearance } from '@src/components/Button';
import { FEATURED_APPLICANTS_ROUTE } from '@src/Routes/links';
import { DEFAULT_SPECIALITY_KEY } from '../constants/filters';
import { FeedEmptyStateProps } from './props';
import './styles.scss';

export const FeedEmptyState: FC<FeedEmptyStateProps> = ({ specialityId, specialityName }) => {
  return (
    <div className="featured-applicant-feed-empty-state">
      <h3 className="featured-applicant-feed-empty-state__title">
        There’s no one new{' '}
        {!specialityName || !specialityId || specialityId === DEFAULT_SPECIALITY_KEY ? '' : `in ${specialityName}`}
      </h3>

      <p className="featured-applicant-feed-empty-state__text">
        Unfortunately, there is no one new{' '}
        {!specialityId || specialityId === DEFAULT_SPECIALITY_KEY ? '' : `in ${specialityName}`} from <br />
        yesterday’s batch who published their profile and is open for <br />
        headhunting. Check back tomorrow.
      </p>

      <Button
        appearance={Appearance.INVISIBLE}
        className="featured-applicant-feed-empty-state__button"
        isLink
        to={FEATURED_APPLICANTS_ROUTE}
      >
        Open in search
      </Button>
    </div>
  );
};
